import { Dialog } from "@radix-ui/themes";
import { mediaQueryPoint, useMediaQuery } from "@hooks";
import './popup.scss'

// Tỉ lệ thu nhỏ popup trên DESKTOP (đồng bộ với việc thu nhỏ cả app). Chỉnh 1 số
// này để to/nhỏ hơn. Dùng thuộc tính CSS `scale` (KHÔNG phải `transform`) để không
// đè lên animation mở/đóng của Radix (vốn animate `transform`) — hai cái nhân với
// nhau nên vẫn mượt, và Radix căn giữa bằng flex/margin nên scale quanh tâm vẫn
// giữa màn hình. Mobile giữ nguyên cỡ thật.
const DESKTOP_POPUP_SCALE = 0.8;

export default function Popups({
	open,
	onOpenChange,
	children,
	className,
	contentProps,
	disableOutsideClose = false,
}) {
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);
	return (
		<Dialog.Root open={open} onOpenChange={onOpenChange}>
			<Dialog.Content
				{...contentProps}
				onPointerDownOutside={(e) => {
					if (disableOutsideClose) e.preventDefault();
					contentProps?.onPointerDownOutside?.(e);
				}}
				onInteractOutside={(e) => {
					if (disableOutsideClose) e.preventDefault();
					contentProps?.onInteractOutside?.(e);
				}}
				onEscapeKeyDown={(e) => {
					if (disableOutsideClose) e.preventDefault();
					contentProps?.onEscapeKeyDown?.(e);
				}}
				style={{
					width: "100vw",
					maxWidth: "700px",
					padding: 0,
					// chuỗi để React không tự thêm 'px' vào value của `scale`
					...(isMobile ? null : { scale: `${DESKTOP_POPUP_SCALE}` }),
					...contentProps?.style,
				}}
				className={`
				overflow-hidden
				${className || ""}
			`}
			>
				{children}
			</Dialog.Content>
		</Dialog.Root>
	);
}